import { API_URL } from '../config';
import { makeApiCall } from '../_common/api.utils';

export const newspaperApproval = async (data: any) => {
	const URL = `${API_URL}GetNewspaperAllowancesByOrganisationID`;
	if (process.env.NODE_ENV === 'development') console.log('API URL:', URL);
	if (process.env.NODE_ENV === 'development') console.log('Request params:', data);
	const requestData = {
		newspaperApprovalToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const approveNewspaper = async (data: any) => {
	const URL = `${API_URL}ApproveNewspaperAllowance`;
	if (process.env.NODE_ENV === 'development') console.log('API URL:', URL);
	if (process.env.NODE_ENV === 'development') console.log('Request params:', data);
	const requestData = {
		approveNewspaperToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const rejectNewspaper = async (data: any) => {
	const URL = `${API_URL}RejectNewspaperAllowance`;
	if (process.env.NODE_ENV === 'development') console.log('API URL:', URL);
	if (process.env.NODE_ENV === 'development') console.log('Request params:', data);
	const requestData = {
		rejectNewspaperToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const bulkApproveNewspaper = async (data: any) => {
	const URL = `${API_URL}BulkApproveNewspaperAllowances`;
	if (process.env.NODE_ENV === 'development') console.log('API URL:', URL);
	if (process.env.NODE_ENV === 'development') console.log('Request params:', data);
	const requestData = {
		bulkApproveNewspaperToken: data,
	};
	return makeApiCall(URL, requestData);
};

export const deleteNewspaper = async (data: any) => {
	const URL = `${API_URL}DeleteNewspaperAllowance`;
	if (process.env.NODE_ENV === 'development') console.log('API URL:', URL);
	if (process.env.NODE_ENV === 'development') console.log('Request params:', data);
	const requestData = {
		deleteNewspapertoken: data,
	};
	return makeApiCall(URL, requestData);
};
